/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const SUPPORTED_CURRENCIES: Record<
  string,
  { shortSymbol: string; longform: string }
> = {
  AUD: { shortSymbol: 'A$', longform: 'Australian Dollar' },
  BHD: { shortSymbol: 'د.ب', longform: 'Bahraini Dinar' },
  BDT: { shortSymbol: '৳', longform: 'Bangladesh Taka' },
  GBP: { shortSymbol: '£', longform: 'British Pound' },
  BND: { shortSymbol: 'B$', longform: 'Brunei Dollar' },
  KHR: { shortSymbol: '៛', longform: 'Cambodian Riel' },
  CNY: { shortSymbol: '¥', longform: 'Chinese Renminbi Yuan' },
  EUR: { shortSymbol: '€', longform: 'Euro' },
  HKD: { shortSymbol: 'HK$', longform: 'Hong Kong Dollar' },
  INR: { shortSymbol: '₹', longform: 'Indian Rupee' },
  IDR: { shortSymbol: 'Rp', longform: 'Indonesia Rupiah' },
  JPY: { shortSymbol: 'JP¥', longform: 'Japanese Yen' },
  KZT: { shortSymbol: '₸', longform: 'Kazakhstani tenge' },
  KES: { shortSymbol: 'KEs', longform: 'Kenyan Shillings' },
  MOP: { shortSymbol: 'MOP$', longform: 'Macau Pataca' },
  MYR: { shortSymbol: 'RM', longform: 'Malaysia Ringgit' },
  NPR: { shortSymbol: 'रु', longform: 'Nepalese Rupee' },
  NZD: { shortSymbol: 'NZ$', longform: 'New Zealand Dollar' },
  PKR: { shortSymbol: 'Rs', longform: 'Pakistani Rupee' },
  PHP: { shortSymbol: '₱', longform: 'Philippines Peso' },
  RWF: { shortSymbol: 'FRw', longform: 'Rwandan Franc' },
  SAR: { shortSymbol: '﷼', longform: 'Saudi Riyal' },
  SGD: { shortSymbol: 'S$', longform: 'Singapore Dollar' },
  KRW: { shortSymbol: '₩', longform: 'South Korean Won' },
  LKR: { shortSymbol: '₨', longform: 'Sri Lankan rupee' },
  TWD: { shortSymbol: 'NT$', longform: 'Taiwanese NT Dollar' },
  TZS: { shortSymbol: 'TSh', longform: 'Tanzanian Shillings' },
  THB: { shortSymbol: '฿', longform: 'Thailand Baht' },
  TRY: { shortSymbol: '₺', longform: 'Turkish lira' },
  USD: { shortSymbol: '$', longform: 'US Dollar' },
  UGX: { shortSymbol: 'USh', longform: 'Ugandan Shillings' },
  UZS: { shortSymbol: "so'm", longform: 'Uzbekistani Som' },
  VND: { shortSymbol: '₫', longform: 'Vietnamese Dong' },
} as const;

export type SupportedCurrencies = keyof typeof SUPPORTED_CURRENCIES;

export const DEFAULT_CURRENCY: SupportedCurrencies = 'MYR';

export const CURRENCY_LIST = Object.entries(SUPPORTED_CURRENCIES).map(
  ([code, data]) => ({
    id: code,
    primaryText: `${code} - ${data.longform}`,
  }),
);
